import { useExtractionQuery } from "../../../../queries/useExtractionQuery";
import { useEffect, useMemo } from "react";

interface UseExtractionDataProps {
  datasetId: string;
  coordinates?: number[];
  pointLabel?: string;
  gridCellSize: string;
  waterDepth: string;
  timeStepInterval: string;
  metadata: any;
  isAdvanceAnalyticsOrValidation: boolean;
  onDataExtracted: (data: any) => void;
}

export const useExtractionData = ({
  datasetId,
  coordinates,
  pointLabel,
  gridCellSize,
  waterDepth,
  timeStepInterval,
  metadata,
  isAdvanceAnalyticsOrValidation,
  onDataExtracted
}: UseExtractionDataProps) => {
  const extractionQuery = useExtractionQuery(
    datasetId,
    coordinates!,
    pointLabel || '',
    gridCellSize,
    waterDepth,
    timeStepInterval,
    metadata,
    isAdvanceAnalyticsOrValidation
  );

  const orderId = useMemo(() => {
    return extractionQuery.data?.find((item) => item.CoordinatesString === coordinates?.join(',') && item.DatasetId === datasetId)?.OrderId
  }, [extractionQuery.data])

  useEffect(() => {
    if (extractionQuery.data) {
      onDataExtracted(extractionQuery.data);
    }
  }, [extractionQuery.data, onDataExtracted]);

  return {
    orderId: orderId,
    extractionData: extractionQuery.data,
    isLoading: extractionQuery.isLoading,
    error: extractionQuery.error
  };
};